<template>
    <d2-container type="card" filename="add">
        <el-row :gutter="20" v-loading="loading">
            <el-col :span="14">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="">
                        <user-img img="//cdn.heanny.cn/Courses/" :imageUrl="form.imgurl" url="/api/add.php"
                                  action="addCourseImg" v-on:getImgurl="putImgurl"></user-img>
                    </el-form-item>
                    <el-form-item label="标题">
                        <el-input v-model="form.title" placeholder="标题" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="form.text" type="textarea"
                                  :autosize="{ minRows: 2, maxRows: 4}"
                                  placeholder="请输入内容" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-select v-model="form.user" placeholder="请选择作者">
                            <el-option
                                    v-for="item in authors"
                                    :key="item.username"
                                    :label="item.name"
                                    :value="item.username">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="form.cclass" placeholder="请选择类型">
                            <el-option label="文件" value="file"></el-option>
                            <el-option label="软件" value="software"></el-option>
                            <el-option label="视频" value="video"></el-option>
                            <el-option label="其他" value="all"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                                        v-model="form.time"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="链接">
                        <el-input v-model="form.bdurl" placeholder="链接" clearable></el-input>
                    </el-form-item>
                    <el-form-item v-if="visible" label="密码">
                        <el-input type="password" v-model="form.bdpwd" placeholder="请输入密码">
                            <i slot="suffix" title="显示密码" @click="changePass('show')" style="cursor:pointer;"
                               class="fa fa-eye"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-else label="密码">
                        <el-input type="text" v-model="form.bdpwd" placeholder="请输入密码">
                            <i slot="suffix" title="隐藏密码" @click="changePass('hide')" style="cursor:pointer;"
                               class="fa fa-eye-slash"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="changeloading">立即修改</el-button>
                        <el-button @click="getData">刷新</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <!--<UeDitor></UeDitor>-->
    </d2-container>
</template>

<script>
    import UserImg from "@/pages/components/userImg.vue"
    import dayjs from 'dayjs'

    export default {
        components: {UserImg},
        data() {
            return {
                // filename: __filename,
                visible: true,
                authors: [],
                loading: false,
                changeloading: false,
                form: {
                    id: this.$route.params.id,
                    action: 'addPhoto',
                    title: '',
                    time: function () {
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000);
                        return dayjs(start).format('YYYY-M-D')
                    }(),
                    imgurl: '',
                    cclass: '',
                    user: '',
                    bdurl: '',
                    bdpwd: '',
                }
            }
        },
        methods: {
            putImgurl(data) {
                this.form.imgurl = data
            },
            onSubmit() {
                this.changeloading = true
                this.$request({url: 'updateShareById.do',data: this.form}).then(res => {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.changeloading = false
                }).catch(err => {
                    this.$message.error('修改失败，请重试');
                    this.changeloading = false
                })
            },
            getUserData() {
                const _this = this
                this.loading = true
                this.$request({
                    url: 'getAuthors.do', method: 'post', data: {
                        action: 'getAuthor',
                    }
                }).then(res => {
                    _this.authors = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.authors = []
                        _this.loading = false
                    })

            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({
                    url: 'getShareById.do', method: 'post', data: {
                        action: 'getShareByID',
                        id: this.$route.params.id
                    }
                }).then(res => {
                    _this.form = res
                    _this.form.action = 'changeShareByID'
                    _this.loading = false
                }).catch((error) => {
                    this.msg = error
                    _this.loading = false
                })

            },
            changePass(value) {
                this.visible = !(value === 'show');
            }
        },
        created() {
            this.getUserData()
        },
        mounted() {
            this.$nextTick(function () {
                this.getData();
            });
        }
    }
</script>
